import { getState, patchState, signalStoreFeature, withHooks, withMethods, withState } from '@ngrx/signals';

type SelectedViewMode = 'list' | 'cards';

type ViewMode = {
    selectedViewMode: SelectedViewMode;
}

const initialState: ViewMode = {
    selectedViewMode: 'list',
};

export function withViewMode() {
    return signalStoreFeature(
        withState(initialState),
        withMethods((store) => ({
            updateSelectedViewMode(mode: SelectedViewMode) {
                patchState(store, { selectedViewMode: mode });
              },

        })),
    );
}